import {useEffect} from 'react';
import {
  HeadingSize,
  Label,
  LabelType,
  Table,
  TableColumn
} from '@fs/uikit-react';
import './Roles.css';
import {useRoles} from '@/contexts/RolesContext';

export interface Role {
  id: string;
  name: string;
  description?: string;
}

const RolesPage = () => {
  const { roles, loading, error } = useRoles();

  useEffect(() => {
    if (error) {
      console.error('Error fetching roles:', error);
    }
  }, [error]);

  const columns: TableColumn[] = [
    { key: 'name', title: 'Назва ролі', width: '60%' },
    { key: 'description', title: 'Опис', width: '40%' }
  ];

  return (
    <div className={"container"}>
      <Label
        text={'Ролі'}
        type={LabelType.HEADING}
        headingSize={HeadingSize.L}
      />

      <div style={{ marginTop: '20px' }}>
        <Table
          data={roles || []}
          columns={columns}
        />
        {loading && <div>Завантаження...</div>}
        {error && !loading && (
          <div>Помилка завантаження ролей: {error.message}</div>
        )}
        {!loading && !error && roles?.length === 0 && (
          <div>Немає доступних ролей</div>
        )}
      </div>
    </div>
  );
};

export default RolesPage;
